function setRGBtoHex(r, g, b) {
  function colorToHex(color) {
    const hexadecimal = color.toString(16);
    return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
  }
  return colorToHex(r) + colorToHex(g) + colorToHex(b);
}

export default setRGBtoHex;
